import { Component, OnInit } from '@angular/core';
import {
  RegistrationStepService,
  MemberDetailsRegistration,
  StepType,
  ErrorStateService,
  WizardType,
  RegistrationStepStore,
} from '@fgb/core';



@Component({
  selector: 'fgb-registration-get-provider-details',
  templateUrl: './registration-get-provider-details.component.html',
  styleUrls: ['./registration-get-provider-details.component.scss'],
})
export class RegistrationGetProviderDetailsComponent implements OnInit {
  readonly stepType = StepType.GetProviderDetails;
  readonly wizardTypes = WizardType;
  wizardType?: WizardType;
  hasSubmitted: boolean = false;
  today = new Date();
  loading: boolean = false;

  constructor(
    private registrationStepService: RegistrationStepService,
    private registrationStepStore : RegistrationStepStore,
    public errorService: ErrorStateService,
    ) {}

  ngOnInit() {

    this.submitStep();
  }

  submitStep() {
    this.hasSubmitted = true;

    this.loading = true;

    let personalDetails = { } as MemberDetailsRegistration;

    this.registrationStepStore.remove(this.stepType);
    this.registrationStepService
      .submitRegistrationStepData(this.stepType, personalDetails, false)
      .toPromise()
      .then(() => {
        this.loading = false
        this.registrationStepService
            .fetchRegistrationStepForCurrentWizard(StepType.PersonalDetails, true, true)
            .toPromise()
            .then(() => { this.registrationStepService.navigateToNextStep() });
      });
  }

}
